import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, User, Search, Menu, X, Heart } from 'lucide-react';
import { getCart } from '../utils/cartApi';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const refreshCart = async () => {
      try {
        const currentCart = await getCart();
        setCart(currentCart.items || []);
      } catch (error) {
        console.error('Navbar cart load failed:', error);
      }
    };

    refreshCart();
    window.addEventListener('cartUpdated', refreshCart);
    return () => window.removeEventListener('cartUpdated', refreshCart);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Banarasi", path: "/explore?cat=banarasi" },
    { name: "Silk", path: "/explore?cat=silk" },
    { name: "Cotton", path: "/explore?cat=cotton" },
    { name: "Wholesale", path: "/wholesale" },
    { name: "About", path: "/#about" },
  ];

  return (
    <header className="block bg-cover bg-center sticky top-0 z-50 border-b border-[#3d2b1f]/5 backdrop-blur-md bg-opacity-95" style={{ backgroundImage: "url('/bg-parchment.jpg')" }}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between md:justify-end items-center py-3 md:py-4 text-[#3d2b1f] text-[10px] font-bold uppercase tracking-[0.2em]">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2">
            {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>

          <div className="flex items-center space-x-5 md:space-x-8">
            <Link to="/explore" className="flex items-center hover:opacity-60 transition" aria-label="Explore">
              <Search size={16} />
            </Link>
            <Link to="/wishlist" className="flex items-center hover:opacity-60 transition" aria-label="Wishlist">
              <Heart size={14} />
            </Link>
            <Link to="/cart" className="relative flex items-center hover:opacity-60 transition" aria-label="Cart">
              <ShoppingBag size={16} />
              {cart.length > 0 && (
                <span className="absolute -right-2 -top-2 min-w-[14px] rounded-full bg-[#3d0c11] px-1 text-center text-[8px] leading-[14px] text-white">
                  {cart.length}
                </span>
              )}
            </Link>
            <Link to="/login" className="flex items-center hover:opacity-60 transition text-[#3d0c11]" aria-label="Login">
              <User size={16} />
            </Link>
          </div>
        </div>

        <div className="flex justify-center py-2">
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="Sri Dorasani Collections" 
              className="h-20 sm:h-24 md:h-32 w-auto object-contain transition-all block" 
            />
          </Link>
        </div>

        <nav className="hidden md:flex justify-center items-center gap-x-8 pb-6 text-[10px] uppercase tracking-[0.25em] font-extrabold text-[#3d2b1f]">
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} className="hover:text-[#8c7b70] transition border-b border-transparent hover:border-[#3d2b1f] pb-1">
              {link.name}
            </Link>
          ))}
        </nav>

        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-[#f5f2e8] border-t border-gray-200 flex flex-col items-center py-8 space-y-6 animate-fadeIn shadow-xl">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path} 
                onClick={() => setIsMenuOpen(false)}
                className="text-[11px] uppercase tracking-[0.3em] font-black text-[#3d2b1f]"
              >
                {link.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;